(() => {
  const initFinalRelease = (section) => {
    if (!section || section.dataset.releaseInitialized === 'true') return;
    section.dataset.releaseInitialized = 'true';

    const checkoutForms = Array.from(section.querySelectorAll('[data-pack-checkout-form]'));
    const selector = section.querySelector('[data-pack-selector]');
    const stickyBar = section.querySelector('[data-sticky-bar]');
    const stickyContinue = section.querySelector('[data-sticky-continue]');

    const packIntent = new URLSearchParams(window.location.search).get('pack');
    const intendedPack = packIntent === '10' || packIntent === '5'
      ? section.querySelector(`[data-pack-number="${packIntent}"]`)
      : null;
    if (intendedPack) {
      intendedPack.classList.add('is-email-intent');
      intendedPack.setAttribute('aria-label', `${packIntent}-box option selected from email`);
    }

    const prepareCheckout = async (form) => {
      const variantInput = form.querySelector('input[name="id"]');
      const button = form.querySelector('[data-pack-checkout-button]');
      const buttonLabel = form.querySelector('[data-pack-checkout-label]');
      const formError = form.querySelector('[data-form-error]');
      const variantId = variantInput?.value || '';
      const available = form.dataset.packAvailable === 'true' && variantId !== '';

      if (!available || !button) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (buttonLabel) buttonLabel.textContent = 'Preparing your checkout…';
      if (formError) {
        formError.hidden = true;
        formError.textContent = '';
      }

      try {
        const clearResponse = await fetch(section.dataset.cartClearUrl || '/cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!clearResponse.ok) throw new Error('We could not prepare your cart. Please try again.');

        const addResponse = await fetch(section.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: { _Campaign: 'FINAL-RELEASE-2026' }
              }
            ]
          })
        });

        if (!addResponse.ok) {
          let message = 'This pack could not be added. It may have just sold out.';
          try {
            const responseBody = await addResponse.json();
            message = responseBody.description || responseBody.message || message;
          } catch (_error) {
            // Keep the customer-safe fallback message.
          }
          throw new Error(message);
        }

        window.location.assign(section.dataset.checkoutUrl || '/checkout');
      } catch (error) {
        if (formError) {
          formError.textContent = error.message || 'Something went wrong. Please try again.';
          formError.hidden = false;
        }
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (buttonLabel) buttonLabel.textContent = button.dataset.defaultLabel || 'Try checkout again';
      }
    };

    checkoutForms.forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        prepareCheckout(form);
      });
    });

    if (stickyContinue && selector) {
      stickyContinue.addEventListener('click', () => {
        selector.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    const updateStickyVisibility = () => {
      if (!stickyBar || !selector) return;
      const selectorRect = selector.getBoundingClientRect();
      const selectorVisible = selectorRect.top < window.innerHeight * 0.82 && selectorRect.bottom > 90;
      const shouldShow = window.scrollY > Math.min(520, window.innerHeight * 0.65) && !selectorVisible;
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);

    const revealItems = section.querySelectorAll('[data-release-reveal]');
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      revealItems.forEach((item) => revealObserver.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-revealed'));
    }
  };

  const initAllFinalReleaseSections = (root = document) => {
    root.querySelectorAll('[data-final-release-section]').forEach(initFinalRelease);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllFinalReleaseSections());
  } else {
    initAllFinalReleaseSections();
  }

  document.addEventListener('shopify:section:load', (event) => initAllFinalReleaseSections(event.target));
})();
